export var extractTicketId = function (url) {
    var pathname = new URL(url).pathname;
    var isOneInbox = pathname.startsWith('/app/helpdesk/one-inbox');
    if (!isOneInbox) {
        return undefined;
    }
    var regex = /(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}/g;
    var found = url.match(regex);
    return found && (found === null || found === void 0 ? void 0 : found.length) > 0 ? found[0] : undefined;
};
//# sourceMappingURL=data-extractors.js.map